module.exports = __webpack_public_path__ + "img/activity_title.05065d71.png";